module.exports = __webpack_public_path__ + "static/media/thumbnail.ef37698a.png";